export default {
  desktop: '(min-width: 1200px)',
  tablet: '(min-width: 990px)',
  mobile: '(min-width: 600px)',
};
